import { Entity, IEntity } from "./Entity";
import { IUser } from "./User";
import { IDirectorate } from "./Directorate";
import { IOrgLevel1 } from "./OrgLevel1";
import { IOrgLevel3 } from "./OrgLevel3";
import { IReportingEntity, ReportingEntity } from "./ReportingEntity";
import { IRiskAppStage } from "./RiskAppStage";
import { IRiskAppIncidentSystem } from "./RiskAppIncidentSystem";
import { IRiskAppIncidentStakeholder } from "./RiskAppIncidentStakeholder";
import { IRiskAppIncidentImpactType } from "./RiskAppIncidentImpactType";
import { IRiskAppIncidentIssue, RiskAppIncidentIssue } from "./RiskAppIncidentIssue";
import { IRiskAppIncidentAction } from "./RiskAppIncidentAction";

export interface IRiskAppIncident extends IReportingEntity {
    IncidentCode?: string;
    StageID?: number;
    SeverityID?: number;
    IncidentTypeID?: number;
    DateOccurred?: Date | null;
    DateReported?: Date | null;
    ReportedByID?: number;
    ReportingChannelID?: number;
    TargetResolutionDate?: Date | null;
    OwnerTypeID?: number;
    OwnerL0ID?: number;
    OwnerL1ID?: number;
    OwnerL2ID?: number;
    OwnerL3ID?: number;
    ManagedByTypeID?: number;
    ManagedByL2ID?: number;
    ManagedByL3ID?: number;
    IncidentManagerID?: number;
    LocationID?: number;
    ExternalNotificationsRequired?: boolean;
    InitialResponseActions?: string;
    InvestigationSummary?: string;
    FinalResolutionSummary?: string;
    LessonsLearned?: string;
    EntityCreatedOn?: Date | null;
    EntityModifiedOn?: Date | null;
    CustomerID?: number;
    ManagedByL2?: IDirectorate;
    ManagedByL3?: IOrgLevel3;
    OwnerL1?: IOrgLevel1;
    OwnerL2?: IDirectorate;
    OwnerL3?: IOrgLevel3;
    IncidentManager?: IUser;
    IncidentType?: IEntity;
    Location?: IEntity;
    ReportedBy?: IUser;
    ReportingChannel?: IEntity;
    Severity?: IEntity;
    Stage?: IRiskAppStage;

    RiskAppIncidentSystems?: IRiskAppIncidentSystem[];
    RiskAppIncidentStakeholders?: IRiskAppIncidentStakeholder[];
    RiskAppIncidentImpactTypes?: IRiskAppIncidentImpactType[];
    RiskAppIncidentIssues?: IRiskAppIncidentIssue[];
    RiskAppIncidentActions?: IRiskAppIncidentAction[];
}

export class RiskAppIncident extends ReportingEntity implements IRiskAppIncident {
    public IncidentCode: string | null = null;
    public StageID: number | null = null;
    public SeverityID: number | null = null;
    public IncidentTypeID: number | null = null;
    public DateOccurred: Date | null = null;
    public DateReported: Date | null = null;
    public ReportedByID: number | null = null;
    public ReportingChannelID: number | null = null;
    public TargetResolutionDate: Date | null = null;
    public OwnerTypeID: number | null = null;
    public OwnerL0ID: number | null = null;
    public OwnerL1ID: number | null = null;
    public OwnerL2ID: number | null = null;
    public OwnerL3ID: number | null = null;
    public ManagedByTypeID: number | null = null;
    public ManagedByL2ID: number | null = null;
    public ManagedByL3ID: number | null = null;
    public IncidentManagerID: number | null = null;
    public LocationID: number | null = null;
    public ExternalNotificationsRequired: boolean | null = null;
    public InitialResponseActions: string | null = null;
    public InvestigationSummary: string | null = null;
    public FinalResolutionSummary: string | null = null;
    public LessonsLearned: string | null = null;
    public EntityCreatedOn: Date | null = null;
    public EntityModifiedOn: Date | null = null;
    public CustomerID: number | null = null;

}
